import React from "react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import ThemeToggle from "./ThemeToggle";
import PayPalDonateButton from "./PayPalDonateButton";
import Logo from "./Logo";

const Navigation = () => {
  const location = useLocation();

  const navItems = [
    { path: "/", label: "Calculator" },
    { path: "/ideal-woman-calculator", label: "Ideal Woman" },
    { path: "/male-partner-calculator", label: "For Men" },
    { path: "/dating-standards-calculator", label: "Standards Test" },
    { path: "/stats", label: "Statistics" },
    { path: "/states", label: "States" },
    { path: "/methodology", label: "Methodology" },
    { path: "/faq", label: "FAQ" },
  ];

  return (
    <nav className="bg-background border-b" role="navigation" aria-label="Main navigation">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Logo />
          
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={cn(
                  "text-sm font-medium transition-colors hover:text-primary",
                  location.pathname === item.path
                    ? "text-primary border-b-2 border-primary pb-1"
                    : "text-muted-foreground"
                )}
                aria-current={location.pathname === item.path ? "page" : undefined}
              >
                {item.label}
              </Link>
            ))}
            <PayPalDonateButton compact />
            <ThemeToggle />
          </div>

          {/* Mobile menu and theme toggle */}
          <div className="md:hidden flex items-center space-x-2">
            <ThemeToggle />
            <details className="relative">
              <summary className="cursor-pointer p-2 text-muted-foreground hover:text-primary">
                <span className="sr-only">Open main menu</span>
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </summary>
              <div className="absolute right-0 mt-2 w-48 bg-background border rounded-md shadow-lg z-50">
                <div className="py-1">
                  {navItems.map((item) => (
                    <Link
                      key={item.path}
                      to={item.path}
                      className={cn(
                        "block px-4 py-2 text-sm transition-colors hover:bg-muted",
                        location.pathname === item.path
                          ? "text-primary bg-muted"
                          : "text-muted-foreground"
                      )}
                    >
                      {item.label}
                    </Link>
                  ))}
                  <div className="px-4 py-2 border-t">
                    <PayPalDonateButton compact />
                  </div>
                </div>
              </div>
            </details>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;